<template>
  <v-app>
    <v-app-bar app flat>
      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-toolbar-title>
        <router-link to="/" custom v-slot="{ navigate }">
          <span @click="navigate" role="link" style="cursor: pointer">
            <v-icon v-if="isExpert" large color="amber">
              mdi-star-circle
            </v-icon>
            Инновационные технологии в здравоохранении (ИТЗ)
          </span>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-btn text v-for="item in menuItems" :key="item.title" :to="item.link">
          <v-icon>
            {{ item.icon }}
          </v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <the-notification></the-notification>

    <v-main>
      <router-view />
    </v-main>

    <the-footer></the-footer>
  </v-app>
</template>

<script>
import { default as TheNotification } from "./layout/Notification.vue";
import TheFooter from "./components/TheFooter";

import { mapGetters } from "vuex";
import { GETTERS } from "./store";

export default {
  name: "App",

  components: { TheFooter, TheNotification },

  data: () => ({ snackbar: false }),
  computed: {
    ...mapGetters({
      isExpert: GETTERS.USER_IS_EXPERT,
    }),
    menuItems() {
      if (this.$route.name === "Score") {
        const menu = [
          // {
          //   title: "Единая входная карта ИТЗ",
          //   link: { name: "Card", params: { id: -1 } },
          // },
          { title: "Методика и система оценки", link: { name: "About" } },
        ];
        if (!this.isExpert) {
          menu.push({ title: "Вход для экспертов", link: { name: "Expert" } });
        }
        return menu;
      }
      return [
        { title: "Методика и система оценки", link: { name: "About" } },
        { title: "Аналитика и оценка ИТЗ", link: { name: "Score" } },
      ];
    },
  },
};
</script>
